module.exports = __webpack_public_path__ + "static/media/ios-fastforward.1be79749.svg";